export default {
  getOrgTypes: (state) => state.orgTypes,
  getOrgData: (state) => state.orgData,
  getOrgList:(state) => state.orgList,
}